<template>
  <div class="layerWrap">
    <div class="in">

      <div class="layerCont">
        <!-- head -->
        <div class="top">
          <a href="javascript:void(0)" class="close" @click="close"><img src="@/assets/images/common/ico_close.png" alt="닫기" /></a>
          배송지 변경
        </div>
        <!-- //head -->

        <!-- contents -->
        <div class="contents form mgTop20">
          <div class="row">
            <label class="label" for="name">받으실분 이름</label>
            <input type="text" placeholder="받으실분 이름을 입력하세요" id="name" class="form-control w100" v-model="form.receiverName"/>
          </div>
          <div class="row">
            <label class="label" for="phone_1">휴대폰번호</label>
            <input type="text" placeholder="휴대폰번호를 입력하세요" id="phone_1" class="form-control w100"
                   v-model="form.receiverContact1" @keyup="checkPhoneNum"/>
          </div>
          <div class="row">
            <label class="label" for="phone_2">연락처</label>
            <input type="text" placeholder="연락처를 입력하세요" id="phone_2" class="form-control w100"
                   v-model="form.receiverContact2" @keyup="checkPhoneNum"/>
          </div>
          <div class="row">
            <label class="label">주소</label>
            <div class="address">
              <input type="text" placeholder="우편번호를 검색하세요" class="form-control" v-model="form.receiverZipCd" readonly/>
              <a href="javascript:void(0)" class="btn-border" @click="findZipcode">우편번호 검색</a>
              <div class="zipcodeWrap" ref="embed"></div>
            </div>
            <input type="text" placeholder="우편번호를 검색하세요" class="form-control w100" v-model="form.receiverAddress" readonly/>
            <input type="text" placeholder="세부 주소를 입력하세요" class="form-control w100" v-model="form.receiverDetailAddress"/>
          </div>
          <div class="row">
            <label class="label" for="memo">배송 메모</label>
            <input type="text" placeholder="배송 메모를 입력하세요" id="memo" class="form-control w100" v-model="form.deliveryMemo"/>
          </div>
        </div>
        <!-- //contents -->

        <!-- bottom -->
        <div class="bottom">
          <a class="btn-midBlack w100" @click="submit"><i class="ic-delivery customStyle"></i> 배송지변경</a>
        </div>
        <!-- //bottom -->
      </div>

    </div>

    <loadingCont v-if="loading"></loadingCont>

  </div>
</template>

<script>
import http from '@/api/shopBy'
import regExp from "@/lib/regExp";
import loadingCont from "@/components/Common/Loading.vue"
export default {
  name: "CancelLayer-b3b5e5",
  props: ['orderNo'],
  components: {
    loadingCont
  },
  data() {
    return {
      loading: true,
      form: {
        receiverZipCd: "",
        receiverAddress: "",
        receiverJibunAddress: "",
        receiverDetailAddress: "",
        receiverName: "",
        receiverContact1: "",
        receiverContact2: "",
        customsIdNumber: "",
        countryCd: "KR",
        deliveryMemo: ""
      }
    }
  },
  created() {
    this.getOrderInfo();
  },
  methods: {
    getOrderInfo() {
      http.get(`/profile/orders/${this.orderNo}`)
        .then(({data}) => {
          this.form = data.shippingAddress;
        }).finally(() => {
          this.loading = false;
        })
    },
    submit() {
      this.loading = true
      if(!this.validation()){
        this.loading = false
        return;
      }

      if(confirm('배송지를 변경 하시겠습니까?')){
        this.form.receiverJibunAddress = this.form.receiverAddress + ' ' + this.form.receiverDetailAddress;
        http.put(`/profile/orders/${this.orderNo}/deliveries`, this.form)
          .then(() => {
            alert('배송지 변경이 완료되었습니다.')
            this.$emit('close')
          }).catch(err => {
            console.log(err)
            alert(err.response.data.message)
          }).finally(() => {
            this.loading = false
          })
      }
    },
    validation () {
      // 필수입력란
      const arr = [
        { id: '받으실분 이름', value: this.form.receiverName },
        { id: '휴대폰번호', value: this.form.receiverContact1 },
        { id: '우편번호', value: this.form.receiverZipCd },
        { id: '주소', value: this.form.receiverAddress },
        { id: '세부 주소', value: this.form.receiverDetailAddress }
      ];

      for(let i = 0; i < arr.length; i++) {
        if(!arr[i].value) {
          alert(arr[i].id + '을(를) 입력해주세요.');
          return false;
        }
      }

      return true;
    },
    checkPhoneNum (e) {
      const regex = /^[0-9\b -]{0,13}$/;
      if (!regex.test(e.target.value)) {
        e.target.value = e.target.value.slice(0, -1);
      }
      e.target.value = regExp.phoneFormatter(e.target.value);
    },
    close() {
      this.$emit('close')
    },
    findZipcode () {
      new window.daum.Postcode({
        oncomplete: (data) => {
          this.form.receiverZipCd = data.zonecode;
          this.form.receiverAddress = data.address;
        }
      }).embed(this.$refs.embed);
    },
  }
}
</script>

<style lang="scss" scoped>
.ic-delivery.customStyle{
  font-size: 18px;
  margin-right: 10px;
}
</style>